/**
 * Estado inicial ao registrar uma entrega (sem fluxo "instantâneo" com PIN na criação).
 */
export function buildNewDeliveryState({
  initialDestination,
  creatorIsRecepcao,
  creatorName,
}) {
  if (initialDestination === 'dono') {
    if (creatorIsRecepcao) {
      return {
        status: 'at_reception',
        current_holder: 'recepcao',
        location: 'Na Recepção',
        note: `Recebido por ${creatorName} — direto ao dono (concluir com Entrega c/ Senha)`,
        pendingOwnerHandoff: true,
      };
    }
    return {
      status: 'received_portaria',
      current_holder: 'portaria',
      location: 'Na Portaria — direto ao dono',
      note: `Recebido por ${creatorName} — direto ao dono (concluir com Entrega c/ Senha)`,
      pendingOwnerHandoff: true,
    };
  }
  if (creatorIsRecepcao) {
    return {
      status: 'at_reception',
      current_holder: 'recepcao',
      location: 'Na Recepção',
      note: `Recebido por ${creatorName} na Recepção`,
      pendingOwnerHandoff: false,
    };
  }
  return {
    status: 'transit_to_reception',
    current_holder: 'recepcao',
    location: 'A caminho da Recepção',
    note: `Enviado à Recepção por ${creatorName} — aguardando confirmação`,
    pendingOwnerHandoff: false,
  };
}

/** Portaria pode concluir com PIN: itens na portaria, em trânsito (antes da recepção confirmar) ou legado preso em aguardando dono. */
export function portariaCanDeliverWithPin(d) {
  if (!d) return false;
  if (d.status === 'received_portaria') return true;
  if (d.status === 'transit_to_reception') return true;
  return d.status === 'waiting_confirmation' && d.current_holder === 'dono';
}
